import clsx from 'clsx'
import React, { useState } from 'react'

import Input, {
  IInputProps
} from '@/components-latest/primitives/Controls/Input'
import { Invisible, Visible } from '@/components-latest/primitives/Icons'

import Styles from './PasswordInput.module.scss'

const replaceStringByDots = (value: IInputProps['value']) => {
  if (typeof value !== 'string') return

  return '●'.repeat(`${value}`.length)
}

type IPasswordInputProps = Omit<IInputProps, 'type'>

const PasswordInput = React.forwardRef<HTMLInputElement, IPasswordInputProps>(
  ({ className, value, dir, ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false)

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword)
    }

    const type = showPassword ? 'text' : 'password'

    return (
      <div className={clsx(className, Styles.container)}>
        <Input
          className={clsx(className, Styles.input, {
            [Styles.rtl]: dir === 'rtl'
          })}
          dir={dir}
          ref={ref}
          value={value}
          type={type}
          {...props}
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className={clsx(Styles.toggleVisibilityButton, {
            [Styles.empty]: typeof value === 'string' && !value?.length,
            [Styles.buttonRtl]: dir === 'rtl'
          })}>
          {showPassword ? <Invisible /> : <Visible />}
        </button>
      </div>
    )
  }
)
PasswordInput.displayName = 'PasswordInput'

export default PasswordInput
